import gql from 'graphql-tag';

export const chimeraUserInformationQuery = gql`
  query getUserInformation {
    chimera {
      me {
        name
        firstName
        lastName
        roles {
          name
        }
        settings {
          experiments {
            migrationToClassroomsEnabled
          }
        }
        featureFlags(
          names: [
            "redirect-to-classrooms"
            "social-metaverse"
            "new-terms-update-dialog"
            "public-video-notes"
            "equal-web-accessibility-widget"
            "undergrad-classrooms-due-date-warning"
            "grade-activities-via-ai"
            "verify-microcertificates-eligibility-automatically"
            "ug-lms-grade-worthy-activities"
            "should-show-classrooms-ug-onboarding"
            "ug-lms-study-calendar-google-integration"
            "ug-lms-onboarding-v-2"
            "ug-lms-ticket-central"
            "ug-lms-chat-bot"
          ]
        )
        pictureSHA
        courses {
          _id
          slug
          name
          dexCourseId
          shouldRedirectToClassrooms
          dexCourseAvailability
          category {
            slug
            name
          }
        }
      }
    }
  }
`;
